import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AgentLookupResponse, AgentLookupParams } from '../models/agent-lookup.model';

@Injectable({ providedIn: 'root' })
export class AgentLookupApiService {
  private readonly base = `${environment.apiUrl}api/agents`;

  constructor(private http: HttpClient) {}

  getAgents(params?: AgentLookupParams): Observable<AgentLookupResponse[]> {
    let httpParams = new HttpParams();
    if (params?.teamId != null) httpParams = httpParams.set('teamId', params.teamId);
    if (params?.availableOnly) httpParams = httpParams.set('availableOnly', 'true');
    if (params?.languageCode) httpParams = httpParams.set('languageCode', params.languageCode);
    if (params?.includePresence) httpParams = httpParams.set('includePresence', 'true');
    if (params?.includeCapacity) httpParams = httpParams.set('includeCapacity', 'true');
    return this.http.get<AgentLookupResponse[]>(this.base, { params: httpParams });
  }
}
